import styled from "styled-components";

export const MainScreen = styled.div`
  width: 100vw;
  height: 100vh;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  display: flex;
  flex-direction: column;
  color: white;
  font-size: 18px;
  
  a {
    color: white;
  }
`